import { transformMessage } from 'shared/domains/feedback/utils/transformMessage';
export function transformThread(options) {
    const { thread, inviteId, documentId } = options;
    const transform = transformMessage(thread);
    return Object.assign(Object.assign({}, thread), { messages: thread.messages.map(transform).reverse(), documentId,
        inviteId });
}
